import { getToken } from "web/constants/urls";

import type { IStoredToken, IToken } from "web/types/Token";

import { request } from "web/api";

import clearStorageAndRedirectToLogin from "./clearStorageAndRedirectToLogin";
import decodeTokenExpiry from "./decodeTokenExpiry";
import newRelicErrorReport from "./newRelicErrorReport";
import persistToken from "./persistToken";

let webTokenPromise: Promise<IToken | null> | null = null;

const getTokenWeb = async (): Promise<IStoredToken | null> => {
  try {
    const response = await (webTokenPromise ??=
      request<Promise<IToken>>(getToken));

    if (!response?.success) {
      return null;
    }

    const { token, accessToken, idToken } = response;
    const { exp, ttl } = decodeTokenExpiry(accessToken);
    const storedToken: IStoredToken = { token, accessToken, idToken, exp, ttl };

    persistToken(storedToken);

    return storedToken;
  } catch (error) {
    const status = (error as { response?: { status?: number } })?.response
      ?.status;

    if (status !== 401) {
      newRelicErrorReport(
        error,
        "web-app/web/utils/system/essentials/getToken.ts - catch"
      );
    }

    if (status === 401 && window.location.pathname !== "/sso/error") {
      clearStorageAndRedirectToLogin();
    }

    throw error;
  } finally {
    webTokenPromise = null;
  }
};

export default getTokenWeb;
